module.exports = __webpack_public_path__ + "static/partnership_process_obj06@2x-5ffecea1c7fa5469ca8cffac932f9d36.png";